import ApiService from '@/common/api.service'
import AclService from '@/common/acl.service'

const state = {
  errors: null,
  user: {},
  lang: localStorage.getItem('language') || 'ar',
  isAuthenticated: false,
}

const getters = {
  auth(state) {
    return state.user
  },
  permissions(state) {
    return state.user.current_entity_permissions || []
  },
  roles(state) {
    return state.user.current_entity_roles || []
  },
  hasPanel(state, getters) {
    const panels = getters.roles.concat(getters.permissions).map(i => i.panel_name)
    return panel_name => panels.includes(panel_name) || state.user.is_superadmin
  },
  userShortName(state) {
    const lang = state.lang === 'ar' ? 'ar' : 'en'
    return `${state.user['first_name_' + lang]} ${state.user['last_name_' + lang]}`
  },
  isAuthenticated(state) {
    return state.isAuthenticated
  },
}

const actions = {
  login(_, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post('login', credentials)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(({ response }) => reject(response))
    })
  },
  logout() {
    return ApiService.post('logout')
  },
  verifyAuth({ state, commit }) {
    return new Promise((resolve, reject) => {
      if (state.isAuthenticated) {
        resolve(state.user)
        return
      }
      ApiService.get('is-logged-in')
        .then(({ data }) => {
          if (data.message === 'success') {
            commit('setAuth', data.user)
          }
          resolve(data.user)
        })
        .catch(({ response }) => {
          reject(response)
        })
    })
  },
  updateAvatar({ commit }, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('users/update-avatar', payload)
        .then(({ data }) => {
          commit('setAvatar', data.image)
          resolve(data)
        })
        .catch(reject)
    })
  },
}

const mutations = {
  setAvatar(state, img) {
    state.user.image = img
  },
  setError(state, error) {
    state.errors = error
  },
  setAuth(state, user) {
    state.isAuthenticated = true
    state.user = user
    state.errors = {}
    const permissions = user.current_entity_permissions ? user.current_entity_permissions.map(perm => perm.name.en) : []
    const roles = user.current_entity_roles ? user.current_entity_roles.map(role => role.name.en) : []
    if (user.type) roles.push(user.type)
    if (user.is_superadmin) roles.push('superadmin')
    AclService.setUserPermissions(permissions)
    AclService.setUserRoles(roles)
  },
  purgeAuth(state) {
    state.isAuthenticated = false
    state.user = {}
    state.errors = {}
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
